<template>
  <div>
    <div class="top">
      <button type="button" v-b-toggle="'sidebar'">
        <i class="material-icons">menu</i>
      </button>
      <div id="bg" v-if="menu_status" v-b-toggle="'sidebar'"></div>

      <div
        class="ms-auto"
        title="Logout"
        @click="$router.push('/logout').catch(() => {})"
      >
        <p>
          <span class="d-none d-sm-inline-block me-1">{{
            $t("page.main.welcome")
          }}</span
          >{{ nickname }}<br />
          <span class="fs-12 text-date">{{ date }}</span>
        </p>
        <i class="material-icons">logout</i>
      </div>
    </div>
    
    <div
      class="container-title flex-column flex-lg-row justify-content-start justify-content-md-between align-items-lg-center"
      v-if="name !== 'Login' && name !== 'Main'"
    >
      <h3 class="montserrat">{{ subtitle }}</h3>
      <nav :aria-label="$t('text.common.breadcrumb')">
        <ol class="breadcrumb mt-2 mt-lg-0">
          <li class="breadcrumb-item">
            <a @click="forceRerender('/')" class="more"
              ><a>{{ $t("text.common.home") }}</a></a
            >
          </li>
          <li class="breadcrumb-item">
            <a
              class="more"
              @click="
                forceRerender($route.matched[0].path && $route.matched[0].path)
              "
              ><a>{{ step1 }}</a>
            </a>
          </li>
          <li class="breadcrumb-item" v-if="step2">
            <a
              class="more"
              @click="
                forceRerender(
                  $route.matched[1].meta.location &&
                    $route.matched[1].meta.location
                )
              "
              ><a>{{ step2 }}</a>
            </a>
          </li>
          <li class="breadcrumb-item" aria-current="page" v-if="step3">
            <a
              class="more"
              @click="
                forceRerender($route.matched[2].path && $route.matched[2].path)
              "
              ><a>{{ step3 }}</a>
            </a>
          </li>
        </ol>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: "Location",
  props: ["menu_status"],
  data() {
    return {
      date: this.$dayjs()
        .utc()
        .utcOffset(
          parseInt(this.$store.state.timezone.timezone_offset) || 9,
          false
        )
        .format("YYYY-MM-DD HH:mm:ss"),
      nickname: sessionStorage.getItem("nickname") || "",
      timezone_name: this.$store.state.timezone.timezone_name,
      timezone_offset: this.$store.state.timezone.timezone_offset,
    };
  },
  methods: {
    forceRerender: function (val) {
      this.$store.commit("setSearchData", {});
      this.$store.commit("forceRerender");
      this.$router.push(val).catch(() => {});
    },
  },
  computed: {
    subtitle: function () {
      return this.$route.meta.subtitle ? this.$route.meta.subtitle : "";
    },
    step1: function () {
      return this.$route.meta.step ? this.$route.meta.step[0] : "";
    },
    step2: function () {
      return this.$route.meta.step ? this.$route.meta.step[1] : false;
    },
    step3: function () {
      return this.$route.meta.step ? this.$route.meta.step[2] : false;
    },
    name: function () {
      return this.$route.name ? this.$route.name : "";
    },
    m_subtitle: function () {
      return this.$route.meta.m_subtitle ? this.$route.meta.m_subtitle : "";
    },
    menu_num: function () {
      return this.$route.meta.menu_num || "";
    },
    path: function () {
      console.log("matched[0]", this.$route.matched[0]);
      console.log("matched[1]", this.$route.matched[1]);
      console.log("matched[2]", this.$route.matched[2]);
    },
  },
};
</script>
